import { Component, Input, OnChanges, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { SideMenuService } from '../../../../sg-base/sg-base-shared/services/side-menu.service';

@Component({
  selector: 'app-top-side-menu',
  templateUrl: './top-side-menu.component.html',
  styleUrl: './top-side-menu.component.scss'
})
export class TopSideMenuComponent implements OnDestroy, OnChanges {

  /** Input用:タイトル */
  @Input() inputTitle: string = '';
  /** Input用:TopのItemId */
  @Input() inputTopItemId: string = '';

  /** サイドメニューTOPの名称 */
  title: string = '';
  /** サイドメニューTOPのitemId */
  topItemId: string = '';
  /** サイドメニューTOPの全ての子要素 */
  childrenAuthorityList: any[] = [];
  /** サイドメニューTOP直下の子要素リスト */
  topChildren: any[] = [];
  /** サイドメニューTOPの子要素の非表示リスト */
  notViewList: string[] = [];

  /** アコーディオン開閉状態 */
  panelOpened: boolean = false;

  /** 購読停止用Subject */
  private onDestroy$ = new Subject();

  /**
   * コンストラクタ
   * @param {SideMenuService} sideMenuService
   * @memberof TopSideMenuComponent
   */
  constructor(private sideMenuService: SideMenuService) {
  }

  /**
   * 更新処理
   *
   * @memberof TopSideMenuComponent
   */
  ngOnChanges(): void {
    if (this.inputTitle) {
      this.title = this.inputTitle;
    }

    if (this.inputTopItemId) {
      this.topItemId = this.inputTopItemId;
    }

    this.sideMenuService.getSideMenuAuthorityMap.pipe(takeUntil(this.onDestroy$)).subscribe(sideMenuAuthorityMap => {
      for (let [key, value] of sideMenuAuthorityMap) {
        if (this.title === key.title) {
          this.childrenAuthorityList = value;
        }
      }
    });

    this.sideMenuService.getTopChildren.pipe(takeUntil(this.onDestroy$)).subscribe(topChildren => {
      for (let [key, value] of topChildren) {
        if (this.title === key.title) {
          this.topChildren = value;
        }
      }
    });

    this.sideMenuService.getNotViewList.pipe(takeUntil(this.onDestroy$)).subscribe(notViewList => {
      for (let [key, value] of notViewList) {
        if (this.title === key.title) {
          this.notViewList = value;
        }
      }
    });
  }

  /**
   * 後処理
   *
   * @memberof TopSideMenuComponent
   */
  ngOnDestroy(): void {
    // 値の初期化
    this.inputTitle = '';
    this.inputTopItemId = '';

    this.title = '';
    this.topItemId = '';
    this.childrenAuthorityList = [];
    this.topChildren = [];
    this.notViewList = [];
  }

  /**
   * メニューオープン時のコールバック処理
   * @memberof TopSideMenuComponent
   */
  onOpenPanel(): void {
    this.panelOpened = true;
  }

  /**
   * メニュークローズ時のコールバック処理
   * @memberof TopSideMenuComponent
   */
  onClosePanel(): void {
    this.panelOpened = false;
  }

  /**
   * ItemIdから見たサイドメニュー子要素を取得
   * @memberof TopSideMenuComponent
   * 
   * @returns サイドメニュー子要素List
   */
  getUnderChildren(itemId: string): any[] {
    return this.childrenAuthorityList
      .filter(authority => authority.parentItemId === itemId)
      .map(authority => authority);
  }
}
